<!-- ----------------------------------------------- -->
<template>
  <v-card id="rw-detail" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header">
      <span v-if="selectedWarnType === 10" class="com-mb-dialog-title"
        >洪水予報</span
      >
      <span v-if="selectedWarnType === 11" class="com-mb-dialog-title"
        >水位到達情報</span
      >
      <span v-if="selectedWarnType === 20" class="com-mb-dialog-title"
        >水防警報</span
      >
      <span v-if="selectedWarnType === 30" class="com-mb-dialog-title"
        >ダム放流通知</span
      >
      <v-spacer></v-spacer>
      <v-btn v-show="!isFull" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn v-show="isFull" small icon color="white" @click="reductionWindow">
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents pa-0">
      <v-col class="com-mb-dialog-frame">
        <rw-info></rw-info>
        <rw-obs
          v-if="
            selectedWarnType === 10 ||
              selectedWarnType === 11 ||
              selectedWarnType === 20
          "
        ></rw-obs>
        <rw-twn></rw-twn>
        <rw-txt v-if="selectedRwDetailRwFlg"></rw-txt>
        <rw-number v-if="selectedRwDetailRwFlg"></rw-number>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 河川予警報詳細ダイアログ
 * RiverwarnDetail.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util.js";
import RwInfo from "../../../components/mb/RwInfo.vue";
import RwObs from "../../../components/mb/RwObs.vue";
import RwTwn from "../../../components/mb/RwTwn.vue";
import RwTxt from "../../../components/mb/RwTxt.vue";
import RwNumber from "../../../components/mb/RwNumber.vue";

export default {
  /** タグ名 */
  name: "mb-rw-detail",
  mixins: [mixin],
  components: {
    RwInfo,
    RwObs,
    RwTwn,
    RwTxt,
    RwNumber,
  },
  data() {
    return {
      isFull: false,
    };
  },
  mounted() {
    this.$log.debug("[Riverwarn] mounted()");
    this.$store.commit("app/setContent", "Riverwarn");
    // ストアとクエリが異なる場合は、クエリを正としてストアを更新
    if (
      this.$store.state.RiverWarn.selectedWarnReq.cd !=
        this.$route.query["rwcd"] ||
      this.$store.state.RiverWarn.selectedWarnReq.type !=
        this.$route.query["rwtype"]
    ) {
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        cd: Number(this.$route.query["rwcd"]),
        type: Number(this.$route.query["rwtype"]),
      });
    }
    // 履歴モードの場合、選択中予警報を取得
    if (this.isCurrent === false) {
      this.$log.debug("[Riverwarn] mounted() - getSelectedRwDetail()");
      this.getSelectedRwDetail();
    }
  },
  computed: {
    /**
     * 表示時刻
     */
    appTimeRoundRw: {
      get() {
        return Util.formatDate(this.$store.state.app.appTimeRoundRw);
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTimeRoundRw: this.$store.state.app.appTimeRoundRw,
          selectedWarnType: this.$store.state.RiverWarn.selectedWarnReq.type,
          cd: this.$store.state.RiverWarn.selectedWarnReq.cd,
        };
      },
    },
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報情報
     */
    selectedRwDetail: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail;
      },
    },
    /**
     * 観測日時
     */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /**
     * 選択中河川予警報フラグ
     */
    selectedRwDetailRwFlg: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwFlg;
      },
    },
  },
  /** メソッド */
  methods: {
    /** 画面拡大 */
    expansionWindow() {
      this.$log.debug("[Riverwarn] expansionWindow()");
      var dlg = document.getElementById("rw-detail");
      dlg.className = "com-mb-dialog large v-card v-sheet theme--light";
      this.isFull = true;
    },
    /** 画面縮小 */
    reductionWindow() {
      this.$log.debug("[Riverwarn] reductionWindow()");
      var dlg = document.getElementById("rw-detail");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";
      this.isFull = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$log.debug("[Riverwarn] closeDlg()");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    /**
     * 選択中予警報を取得
     */
    getSelectedRwDetail() {
      this.$log.debug("[Riverwarn] getSelectedRwDetail()");
      setTimeout(() => {
        this.$store.dispatch("RiverWarn/getSelectedRwDetail", {
          appTime: this.appTimeRoundRw,
          rwCd: this.reqParam.cd,
          type: this.reqParam.selectedWarnType,
        });
      }, 500);
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[Riverwarn] watch(reqParam)");
      // リクエストパラメータ変更時には再取得
      this.getSelectedRwDetail();
    },
    /**
     * 選択中河川予警報情報変更時
     */
    selectedRwDetail() {
      // データがあれば、地図アイコンをパルスさせるためダム観測所の情報を保存
      if(
        this.$store.state.RiverWarn.selectedRwDetail.mt.ofcCd && 
        this.$store.state.RiverWarn.selectedRwDetail.mt.itmkndCd && 
        this.$store.state.RiverWarn.selectedRwDetail.mt.obsCd
      ) {
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: this.$store.state.RiverWarn.selectedRwDetail.mt.ofcCd,
          itmkndCd: this.$store.state.RiverWarn.selectedRwDetail.mt.itmkndCd,
          obsCd: this.$store.state.RiverWarn.selectedRwDetail.mt.obsCd
        });
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}

#rw-detail {
  right: 4px;
}
</style>
